import type { ResponseMessage } from '@kiddocare-platform/portal-common/base'
import type { CaseReducer, PayloadAction } from '@reduxjs/toolkit'
import { isCacheValid } from '../../../entry.cache'
import type { FamilyCacheState } from '../types'
import type { Beverage } from '@kiddocare-platform/portal-common/family'

const addBeverages: CaseReducer<
  FamilyCacheState,
  PayloadAction<ResponseMessage<Array<Beverage>>>
> = (state, action) => {
  state.beverages = { value: action.payload, cachedAt: Date.now() }
}

const removeBeverages: CaseReducer<FamilyCacheState, PayloadAction<void>> = (state) => {
  state.beverages = undefined
}

const purgeExpiredBeveragesCache: CaseReducer<FamilyCacheState> = (state) => {
  if (!isCacheValid(state.beverages)) {
    state.beverages = undefined
  }
}

export const beveragesReducers = {
  addBeverages,
  removeBeverages,
  purgeExpiredBeveragesCache,
}
